import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Button, Modal, Grid } from 'semantic-ui-react';

// Global Types
import { AppState } from 'services/types';
import { HarvestEventUuid } from 'services/harvestEvents/types';

// Global Actions
import { updateQueryString } from 'services/router/actions';

// Global Workspaces
// @ts-ignore
import { ErrorBoundary } from 'workspaces/redux-error-boundary';
import {
    makeSelectQueryStringValue,
    makeSelectQueryStringNumberValue,
    makeSelectQueryStringBooleanValue
    // @ts-ignore
} from 'workspaces/react-router-selectors';

// Components
// @ts-ignore
import ErrorBoundaryAlert from 'components/ErrorBoundaryAlert';
import RoleGate from 'components/RoleGate';
import {
    ADMIN,
    MANAGER,
    ASSISTANT_MANAGER
} from 'components/RoleGate/constants';

// Child Components
// @ts-ignore
import EventIncompleteContainerGroupGate from './components/EventIncompleteContainerGroupGate';
// @ts-ignore
import ContainerGroupPdfUrlButton from './components/ContainerGroupPdfUrlButton';
// @ts-ignore
import ContainerGroupProgress from './components/ContainerGroupProgress';
// @ts-ignore
import ContainerGroupPdfUrlGate from './components/ContainerGroupPdfUrlGate';
// @ts-ignore
import EventPrintForm from './components/EventPrintForm';

import ContainerGroupSubmittedTimeGate from './components/ContainerGroupSubmittedTimeGate';
import ContainerGroupCancelButton from './components/ContainerGroupCancelButton';

interface ConnectedProps {
    selectedEvent?: HarvestEventUuid;
    eventPrintModal?: boolean;
    selectedContainerGroup?: number;
}

interface DispatchProps {
    updateQueryString: Function;
}

type Props = ConnectedProps & DispatchProps;

export class EventPrintDialogComponent extends React.PureComponent<Props> {
    handleClose = (): void => {
        this.props.updateQueryString({
            eventPrintModal: undefined,
            selectedContainerGroup: undefined
        });
    };

    render(): React.ReactElement | null {
        const {
            selectedEvent,
            eventPrintModal,
            selectedContainerGroup
        } = this.props;

        if (!selectedEvent) {
            return null;
        }

        return (
            <RoleGate requiredRoles={[ADMIN, MANAGER, ASSISTANT_MANAGER]}>
                <Modal
                    size="tiny"
                    open={eventPrintModal}
                    centered={false}
                    onClose={this.handleClose}
                    closeIcon
                >
                    <ErrorBoundary
                        namespace="EventPrintDialog"
                        FallbackComponent={<ErrorBoundaryAlert />}
                    >
                        <EventIncompleteContainerGroupGate
                            harvestEventUuid={selectedEvent}
                            FallbackComponent={
                                <React.Fragment>
                                    <Modal.Header>
                                        Creating Bins in SAP
                                    </Modal.Header>
                                    <Modal.Content>
                                        <ContainerGroupProgress
                                            harvestEventUuid={selectedEvent}
                                        />
                                        <ContainerGroupSubmittedTimeGate
                                            containerGroupId={
                                                selectedContainerGroup
                                            }
                                            showAfterSeconds={300}
                                        >
                                            <ContainerGroupCancelButton
                                                harvestEventUuid={selectedEvent}
                                                label="Cancel"
                                            />
                                        </ContainerGroupSubmittedTimeGate>
                                    </Modal.Content>
                                </React.Fragment>
                            }
                        >
                            <ContainerGroupPdfUrlGate
                                containerGroupId={selectedContainerGroup}
                                FallbackComponent={
                                    <EventPrintForm
                                        harvestEventUuid={selectedEvent}
                                        containerGroupId={
                                            selectedContainerGroup
                                        }
                                        onClose={this.handleClose}
                                    />
                                }
                            >
                                <Modal.Header>Download Bin Labels</Modal.Header>
                                <Modal.Content>
                                    <p>Bin labels were succesfully created</p>
                                    <Grid>
                                        <Grid.Column
                                            mobile={16}
                                            tablet={8}
                                            computer={8}
                                        >
                                            <Button
                                                onClick={this.handleClose}
                                                basic
                                                primary
                                                fluid
                                            >
                                                Done
                                            </Button>
                                        </Grid.Column>
                                        <Grid.Column
                                            mobile={16}
                                            tablet={8}
                                            computer={8}
                                        >
                                            <ContainerGroupPdfUrlButton
                                                containerGroupId={
                                                    selectedContainerGroup
                                                }
                                            />
                                        </Grid.Column>
                                    </Grid>
                                </Modal.Content>
                            </ContainerGroupPdfUrlGate>
                        </EventIncompleteContainerGroupGate>
                    </ErrorBoundary>
                </Modal>
            </RoleGate>
        );
    }
}

const mapStateToProps = createStructuredSelector<AppState, {}, ConnectedProps>({
    selectedEvent: makeSelectQueryStringValue('selectedEvent'),
    eventPrintModal: makeSelectQueryStringBooleanValue('eventPrintModal'),
    selectedContainerGroup: makeSelectQueryStringNumberValue(
        'selectedContainerGroup'
    )
});

export default connect(mapStateToProps, { updateQueryString })(
    EventPrintDialogComponent
);
